import { render, staticRenderFns } from "./CardGroup.vue?vue&type=template&id=48e3e74e&scoped=true&"
import script from "./CardGroup.vue?vue&type=script&lang=js&"
export * from "./CardGroup.vue?vue&type=script&lang=js&"
import style0 from "./CardGroup.vue?vue&type=style&index=0&id=48e3e74e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e3e74e",
  null
  
)

export default component.exports